<template>
  <md-step
    :md-error="error"
    :id="element.uuid"
    v-if="mode"
    :md-done.sync="saveData.value"
    :md-label="saveData.label"
    md-description
  >
    <!-- Step is valid: {{ valid }} -->
    <div class="step-content">
      <h5 v-if="saveData.label" class="label">{{ saveData.label }}</h5>
      <component
        v-for="(el, index) in element.list"
        :uuid="el.uuid"
        :nid="nid"
        :sid="sid"
        :main_sid="main_sid"
        :key="el.uuid"
        :is="el.type"
        :element="el"
        :mode="1"
        :validate="validate"
        :active="active"
        :step="element.uuid"
        :is-draft="isDraft"
        :status="status"
        :showSubmit="showSubmit"
        :validationFails="validationFails"
        :pmode="pmode"
        @submit="$emit('submit')"
        @validate-form="$emit('validate-form')"
        @disable-form-validation="$emit('disable-form-validation')"
        @validation="updateValidation(index, $event)"
        @set-value="$emit('set-value', $event)"
        @quiz-init="$emit('quiz-init', $event)"
        ref="fbChild"

      ></component>
    </div>
    <div class="fb-navigation" v-if="inStepNavigation">
      <md-button
        class="md-secondary fb-prev"
        @click="prevStep"
        v-if="stepIndex > 0 && stepIndex <= steps"
      >Back</md-button>
      <span class="position-relative fb-next">
        <md-button
          :class="'md-raised md-primary fb-next ' + (gatekeeping && !valid ? 'disabled' : '')"
          @click="nextStep"
          v-if="stepIndex < steps - 1 && stepIndex >= 0"
        >Next</md-button>
        <div class="fb-tooltip fb-tooltip-right" v-show="gatekeeping && tooltip">Complete the current step to continue.</div>
      </span>
      <fb-submit-button
        :uuid="this.$uuid.v1()"
        :nid="nid"
        :sid="sid"
        :main_sid="main_sid"
        :element="{}"
        :mode="1"
        :validate="validate"
        :active="active"
        :step="element.uuid"
        :is-draft="isDraft"
        :status="status"
        :showSubmit="showSubmit"
        :validationFails="validationFails"
        :pmode="pmode"
        @submit="$emit('submit')"
        @validate-form="$emit('validate-form')"
        @disable-form-validation="$emit('disable-form-validation')"
        @validation="updateValidation(index, $event)"
        @set-value="$emit('set-value', $event)"
        v-if="submit_button_on_last_step && stepIndex == steps - 1 && countFormCards ==1 && showSubmit == 1"></fb-submit-button>
    </div>
  </md-step>
  <md-card v-else class="md-elevation-2 md-layout-item md-primary fb-step">
    <fb-controll
      :controll="saveData.label || 'Step'"
      @collapse-click="collapsePreview"
      @setting-click="showSettings"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <md-field>
        <label>{{ tempData.label }}</label>
      </md-field>
      <draggable
        @change="updateList"
        class="dragArea full-height"
        tag="div"
        :list="list"
        group="controls"
        :class="{'show-draggable': !list.length}"
      >
        <component
          v-for="(element, index) in list"
          @save-data="updateData(index, $event)"
          @menu-delete="removeItem(index)"

          :uuid="element.uuid"
          :key="element.uuid"
          :is="element.type"
          :element="element"
          :mode="0"
          :validate="validate"
        ></component>
      </draggable>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "./FbElementMixin";
import draggable from "vuedraggable";

export default {
  name: "FbStep",
  props: [
    "element",
    "mode",
    "stepIndex",
    "steps",
    "active",
    "validate-last-step",
    "inStepNavigation",
    "status",
    "showSubmit",
    "validate",
    "pmode",
    "countFormCards",
    "gatekeeping"
  ],
  mixins: [FbElementMixin],
  components: {
    //...components,
    draggable
  },
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value;
      if (this.saveData.value == true) {
        this.$emit("step-done", this.element.uuid);
        this.$emit("set-value", this.value);
      }
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    valid: {
      cache: false,
      get() {
        if (this.isDraft) {
          return true;
        }
        let errors = this.validation.filter(el => {
          return el !== true;

        });
        return errors.length == 0;
      }
    },
    error() {
      if (!this.valid && this.validate) {
        return " ";
      }
      return null;
    }
  },
  data() {
    return {
      tooltip: false,
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || false
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || false
      },
      //validate: false,
      validation: [],
      list: this.element.list || [],
      submit_button_on_last_step: drupalSettings.form_builder ? !!+drupalSettings.form_builder[this.nid].field_submit_button_on_last_step : 0
    };
  },
  methods: {
    nextStep() {
      // code for validation before next step
      // this.validate = true;
      // if (this.valid) {
      //   this.saveData.value = true;
      //   this.$emit("next-step", this.stepIndex);
      //   this.$emit("set-value", this.value);
      // }
      //this.validate = true;
      if (this.gatekeeping && !this.valid) {

        this.tooltip = true;
        setTimeout(() => {
          this.tooltip = false;
        }, 3000);
      }
      this.saveData.value = this.valid;
      this.$emit("next-step", this.stepIndex);
      this.$emit("set-value", this.value);
      //this.validate = false;
    },
    prevStep() {
      this.$emit("prev-step", this.stepIndex);
    },
    updateList(event) {
      this.$emit("save-data", { data: this.saveData, list: this.list });
    },
    updateData(index, event) {
      this.list[index].data = event.data;
      this.list[index].list = event.list;
      this.updateList(event);
    },
    removeItem(index) {
      this.list.splice(index, 1);
      this.updateList();
    },
    updateValidation(index, event) {
      this.validation[index] = event;
      this.validation = this.validation.slice(0);
      this.$emit("validation", this.valid);
    }
  },
  watch: {
    // validateLastStep(val) {
    //   if (val == true) {
    //     //this.validate = true;
    //     //this.$emit("set-value", this.value);
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
.dragArea {
  z-index: 99;
  padding-bottom: 10px;
  position: relative;
  // &::before {
  //   content: "DragAndDrop";
  //   display: block;
  //   position: absolute;
  //   top: 50%;
  //   text-align: center;
  //   width: 100%;
  // }
  min-height: 100px;
  background-color: rgba(255, 255, 255, 0.05);
}
</style>

